import API from "./api";

const InvitationService = {
  getAll: async () => {
    const response = await API.get("/invitations");
    return response.data.donnees;
  },

  create: async (payload: { email: string; role: string }) => {
    const response = await API.post("/invitations", payload);
    return response.data.donnees;
  },

  accepter: async (payload: { token: string; nom?: string }) => {
    const response = await API.post("/invitations/accepter", payload);
    return response.data.donnees;
  },

  annuler: async (id: number) => {
    const response = await API.patch(`/invitations/${id}/annuler`);
    return response.data.donnees;
  },

  supprimer: async (id: number) => {
    const response = await API.delete(`/invitations/${id}`);
    return response.data.donnees;
  },
};

export default InvitationService;
